import React, { useState } from 'react';
import { Box, Button, Collapse, Grid, Paper, Typography } from '@mui/material';
import AWSOnboardingWizard from '../s3_onboarding/OnPremiseWizard';
import DeliveryInfo from './DeliveryInfo';
import ProductOverview from './ProductOverview'; // Import the ProductOverview component

const OrganizationDashboard = ({ organization, adcRows }) => {
    const [isAdcOverviewOpen, setIsAdcOverviewOpen] = useState(false);
    const [isS3WizardOpen, setIsS3WizardOpen] = useState(false);

    const handleToggleAdcOverview = () => {
        setIsAdcOverviewOpen(!isAdcOverviewOpen);
    };

    const handleToggleS3Wizard = () => {
        setIsS3WizardOpen(!isS3WizardOpen);
    };

    return (
        <>
            {/* Add ProductOverview component */}
            <ProductOverview organization={organization} />

            {organization.s3_config?.infra_data?.onprem_config?.onprem_bucket ? (
                <DeliveryInfo
                    organizationId={organization._id}
                    s3Config={organization.s3_config}
                    deliveryFormat={organization.delivery_format}
                />
            ) : (
                <Button
                    fullWidth
                    style={{
                        color: 'white',
                        border: '1px solid lightgray'
                    }}
                    onClick={handleToggleS3Wizard}
                >
                    <Typography variant="h5">
                        {isS3WizardOpen ? "Hide AWS Onboarding Wizard" : "Show AWS Onboarding Wizard"}
                    </Typography>
                </Button>

            )}
            <Collapse in={isS3WizardOpen}>
                <Box mt={4}>
                    {<AWSOnboardingWizard organization={organization} />}
                </Box>
            </Collapse>

            {/* Move ADC Overview button and section to the bottom */}
            {organization.adc_enabled && (
                <>
                    <Button
                        fullWidth
                        style={{
                            color: 'white',
                            border: '1px solid lightgray',
                            marginTop: '20px' // Add margin to separate from previous components
                        }}
                        onClick={handleToggleAdcOverview}
                    >
                        <Typography variant="h5">{isAdcOverviewOpen ? "Hide ADC Overview" : "Show ADC Overview"}</Typography>
                    </Button>

                    <Collapse in={isAdcOverviewOpen}>
                        <Grid container spacing={2}>
                            <Grid item xs={12}>
                                <Paper variant="outlined" sx={{ padding: '20px', marginTop: '20px' }}>
                                    <Typography variant="h5" gutterBottom>
                                        ADC Overview
                                    </Typography>
                                    {adcRows && adcRows.length > 0 ? (
                                        <Grid container spacing={2}>
                                            {/* ADC Statuses and other stats */}
                                            <Grid item xs={12}>
                                                <Typography variant="subtitle2" color="text.secondary">
                                                    Statuses
                                                </Typography>
                                                <Typography variant="body1">
                                                    ADC Enabled: {organization.adc_enabled ? 'True' : 'False'} <br />
                                                    Auction Enabled: {organization.auction_enabled ? 'True' : 'False'} <br />
                                                    Beeswax Cookie Sync: {organization.beeswax_cookie_sync ? 'True' : 'False'} <br />
                                                    BITO HEM Enabled: {organization.bito_hem_enabled ? 'True' : 'False'}
                                                </Typography>
                                            </Grid>
                                            {/* ADC stats */}
                                            {[
                                                { label: 'Total Visits', value: adcRows.reduce((sum, row) => sum + row.visits_count, 0) },
                                                { label: 'Total Visits Resolved', value: adcRows.reduce((sum, row) => sum + row.visits_resolved_count, 0) },
                                                { label: 'Total Distinct Visits', value: adcRows.reduce((sum, row) => sum + row.distinct_visits_count, 0) },
                                                { label: 'Total Distinct Visits Resolved', value: adcRows.reduce((sum, row) => sum + row.distinct_visits_resolved_count, 0) },
                                                { label: 'Total Distinct HEMs Delivered', value: adcRows.reduce((sum, row) => sum + row.distinct_hems_count, 0) },
                                                { label: 'Average % Resolved', value: `${(adcRows.reduce((sum, row) => sum + row.percent_resolved, 0) / adcRows.length * 100).toFixed(2)}%` },
                                                { label: 'Average Unique % Resolved', value: `${(adcRows.reduce((sum, row) => sum + row.unique_percent_resolved, 0) / adcRows.length * 100).toFixed(2)}%` },
                                            ].map((item, index) => (
                                                <Grid item xs={3} key={index}>
                                                    <Paper variant="outlined" sx={{ padding: '10px' }}>
                                                        <Typography variant="subtitle2" color="text.secondary">
                                                            {item.label}
                                                        </Typography>
                                                        <Typography variant="h6">
                                                            {new Intl.NumberFormat().format(item.value)}
                                                        </Typography>
                                                    </Paper>
                                                </Grid>
                                            ))}
                                        </Grid>
                                    ) : (
                                        <Typography variant="body1">No stats collected for {organization.name} yet.</Typography>
                                    )}
                                </Paper>
                            </Grid>
                        </Grid>
                    </Collapse>
                </>
            )}
        </>
    );
};

export default OrganizationDashboard;
